export default "<div id=\"preview\" #preview>\n  <div *ngIf=\"isInitializing\">Loading preview... Please wait.</div>\n</div>\n";